module.exports = __webpack_public_path__ + "img/rightbicep-mesomorph-female.af05ab65.svg";